import { Button, Card, Space } from "antd";
import { ReactNode, useEffect } from "react";
import CustomModal from "../../../components/ui/CustomModal";
import Loader from "../../../components/ui/Loader";
import {
  useGetProtalSingleSubDepartmentQuery,
  useUpdatePortalStatusSubDepartmentMutation,
} from "../../../features/portal/settings/settingsApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL"
    | "PRODUCT_ACTIVITY"
> {
  open: boolean;
  action?: boolean;
  buttonBgDeep?: boolean;
  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: any;
  title?: ReactNode;
  subTitle?: ReactNode;
  buttonName?: string;
  loading?: boolean;
  children?: ReactNode;
}

export default function SubDepartmentStatusUpdateModal({
  title,
  action,
  buttonName,
  buttonBgDeep,
  subTitle,
  handleClose,
  children,
  type,
  data,
  loading,
  ...rest
}: ModalConfirmProps) {
  const {
    data: getProtalSingleSubDepartmentData,
    isError: getProtalSingleSubDepartmentIsError,
    error: getProtalSingleSubDepartmentError,
    isLoading: getProtalSingleSubDepartmentIsLoading,
  } = useGetProtalSingleSubDepartmentQuery(data?.id, { skip: !data?.id });
  const [
    updatePortalStatusSubDepartment,
    { isSuccess, isLoading, isError, error },
  ] = useUpdatePortalStatusSubDepartmentMutation();
  useError(
    getProtalSingleSubDepartmentIsError,
    getProtalSingleSubDepartmentError,
    "Single sub department get data failed"
  );
  useError(isError, error, "Sub Department status updated failed");

  const handleActiveInactiveRole = () => {
    const newData = {
      status:
        getProtalSingleSubDepartmentData?.data?.status === true ? false : true,
    };

    updatePortalStatusSubDepartment({
      data: newData,
      id: data?.id,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      toast(
        "success",
        `${
          getProtalSingleSubDepartmentData?.data?.status === true
            ? `${getProtalSingleSubDepartmentData?.data?.name} has been marked as inactive successfully`
            : `${getProtalSingleSubDepartmentData?.data?.name} is now active again`
        }`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        {data?.id && getProtalSingleSubDepartmentIsLoading ? (
          <Loader />
        ) : (
          <Card className="w-full">
            <h4 className=" font-semibold text-[18px] text-[#5E718D] text-center">
              {`${
                getProtalSingleSubDepartmentData?.data?.status === true
                  ? "Inactive"
                  : "Active"
              } ${getProtalSingleSubDepartmentData?.data?.name}!`}
            </h4>

            <div className=" font-normal text-[14px] text-[#5E718D] text-center">
              {`Are you sure you want to ${
                getProtalSingleSubDepartmentData?.data?.status === true
                  ? "inactive"
                  : "active"
              } ${
                getProtalSingleSubDepartmentData?.data?.name
              } of sub department?`}
            </div>

            <Space className="flex justify-center gap-2 mt-6">
              <Button
                className="normal-dark-button modal-button"
                size="middle"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                onClick={handleActiveInactiveRole}
                loading={isLoading}
              >
                {`Yes, ${
                  getProtalSingleSubDepartmentData?.data?.status === true
                    ? "Inactive"
                    : "Active"
                }`}
              </Button>
            </Space>
          </Card>
        )}
      </CustomModal>
    </>
  );
}
